import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { ContainerStyled, PageHeaderStyled, PageSubTitleStyled } from '../styles/Main';
import { BoxesContainerStyled } from '../styles/Box';
import { PrimaryButtonStyled } from "../styles/Button.js";
import Box from './Box';
import { FormNavContainerStyled } from "../styles/Form.js";


const ModeSelector = ({ mode, setMode, setFormData, handleIncrementFormStep }) => {

    useEffect(() => {
        setFormData({})
    }, [setFormData]);

    const handleModeChange = (newMode) => {
        setMode(newMode);
    };  

    return (
        <ContainerStyled>
            <PageHeaderStyled>Start Analysis</PageHeaderStyled>
            <PageSubTitleStyled>Choose analysis type by zipcode or input manual data</PageSubTitleStyled>
            <BoxesContainerStyled>
                <Box title={'Zip Code Search'} name={'zip'} mode={mode} onClick={handleModeChange} index={0}/>
                <Box title={'Manual Data Input'} name={'manual'} mode={mode} onClick={handleModeChange} index={1}/>
            </BoxesContainerStyled>
            <FormNavContainerStyled $single={true}>
                <PrimaryButtonStyled onClick={handleIncrementFormStep}>Start</PrimaryButtonStyled>
            </FormNavContainerStyled>
            
        </ContainerStyled>
    );
};

ModeSelector.propTypes = {
  mode: PropTypes.string.isRequired,
  setMode: PropTypes.func.isRequired,
  handleIncrementFormStep: PropTypes.func.isRequired
};

export default ModeSelector;